export const PAGE_TYPE = {
  INCOME: "Income",
  DEDUCTION: "Deduction",
};
